import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { IReturnSalesOrderRequestsResponse } from "../../types/api/orderRequestsApi";
import { ITableRequestData } from "../../types/common";
import { ReturnSalesOrderState } from "../../types/features/returnSalesOrderSlice";
import {
  createReturnOrderToSapService,
  getReturnSalesOrderByIdService,
  getReturnSalesOrderTableService,
  updateReturnSalesOrderService,
} from "../../api/returnSalesOrderApi";

export const createReturnSalesOrderData = createAsyncThunk<
  IReturnSalesOrderRequestsResponse,
  { data: any,id:string }
>("returnSalesOrder/createReturnSalesOrderData", async ({data,id}) => {
  const response = await createReturnOrderToSapService(data,id);
  return response.data;
});

export const getReturnSalesOrderData = createAsyncThunk<
  IReturnSalesOrderRequestsResponse,
  ITableRequestData
>(
  "returnSalesOrder/getReturnSalesOrderData",
  async ({ limit, page, status ,order_type}) => {
    const response = await getReturnSalesOrderTableService({
      limit,
      page,
      status,
      order_type
    });
    return response.data;
  }
);
export const getReturnSalesOrderByIdData = createAsyncThunk<
  IReturnSalesOrderRequestsResponse,
  { id: string }
>("returnSalesOrder/getReturnSalesOrderByIdData", async ({ id }) => {
  const response = await getReturnSalesOrderByIdService({ id });
  return response.data;
});

export const updateReturnSalesOrderData = createAsyncThunk<
  IReturnSalesOrderRequestsResponse,
  { id: string; data: any }
>("returnSalesOrder/updateReturnSalesOrderData", async ({ id, data }) => {
  const response = await updateReturnSalesOrderService({ id, data });
  return response.data;
});
const ReturnSalesOrderSlice = createSlice({
  name: "ReturnSalesOrder",
  initialState: {
    returnSalesOrderLoader: false,
    status: false,
    msg: "",
    data: null,
    detail: null,
  } as ReturnSalesOrderState,
  reducers: {
    // filterByOrderType: (state, action: PayloadAction<string>) => {
    //   const orderType = action.payload;
    //   // // console.log(state.data, "state.data");

    //   if (orderType === "expire") {
    //     state.data =
    //       state.data?.filter((record: any) => record.ReturnCode === "R08") ||
    //       null;
    //   } else if (orderType === "return_order") {
    //     state.data =
    //       state.data?.filter((record: any) => record.ReturnCode !== "R08") ||
    //       null;
    //   }
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReturnSalesOrderData.pending, (state) => {
        state.returnSalesOrderLoader = true;
      })
      .addCase(
        getReturnSalesOrderData.fulfilled,
        (state, action: PayloadAction<IReturnSalesOrderRequestsResponse>) => {
          // // // console.log(action.payload, 'action.payload.data');

          state.data = action.payload.order_data;
          state.msg = action.payload.message;
          state.status = true;
          state.returnSalesOrderLoader = false;
        }
      )
      .addCase(getReturnSalesOrderData.rejected, (state, action) => {
        state.returnSalesOrderLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })

      .addCase(createReturnSalesOrderData.pending, (state) => {
        state.returnSalesOrderLoader = true;
      })
      .addCase(
        createReturnSalesOrderData.fulfilled,
        (state, action: PayloadAction<IReturnSalesOrderRequestsResponse>) => {
          // // // console.log(action.payload, 'action.payload.data');

          // state.data = action.payload.order_data;
          state.msg = action.payload.message;
          state.status = true;
          state.returnSalesOrderLoader = false;
        }
      )
      .addCase(createReturnSalesOrderData.rejected, (state, action) => {
        state.returnSalesOrderLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(getReturnSalesOrderByIdData.pending, (state) => {
        state.returnSalesOrderLoader = true;
      })
      .addCase(
        getReturnSalesOrderByIdData.fulfilled,
        (state, action: PayloadAction<IReturnSalesOrderRequestsResponse>) => {
          state.detail = action.payload.order_data;
          state.msg = action.payload.message;
          state.status = true;
          state.returnSalesOrderLoader = false;
        }
      )
      .addCase(getReturnSalesOrderByIdData.rejected, (state, action) => {
        state.returnSalesOrderLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(updateReturnSalesOrderData.pending, (state) => {
        state.returnSalesOrderLoader = true;
      })
      .addCase(
        updateReturnSalesOrderData.fulfilled,
        (state, action: PayloadAction<IReturnSalesOrderRequestsResponse>) => {
          // state.detail = action.payload.data;
          state.msg = action.payload.message;
          state.status = true;
          state.returnSalesOrderLoader = false;
        }
      )
      .addCase(updateReturnSalesOrderData.rejected, (state, action) => {
        state.returnSalesOrderLoader = false;
        state.status = false;
        state.msg = action.error.message;
      });
      
  },
});

// export const { filterByOrderType } = ReturnSalesOrderSlice.actions;  
export default ReturnSalesOrderSlice.reducer;
